import { defineAgenda, param } from '@/shared/navigation/core';
import i18n from '@/shared/lib/i18n';

/**
 * Agenda detailu subkategorie placeholderu — jeden formulář pro založení i editaci. Bez
 * `subcategoryId` = založení, s `subcategoryId` = editace. Otevírá se jako modální vrstva nad
 * seznamem subkategorií.
 */
export const subcategoryDetailAgenda = defineAgenda({
  id: 'app.venua-planner.placeholder-subcategory-detail',
  path: 'app/venua-planner/placeholder-subcategory',
  open: {
    subcategoryId: param.uuid().optional(),
  },
  title: () => i18n.t('schemes.subcategory.agendaTitle', { ns: 'venua-planner' }),
  icon: 'list',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
